import { Component, ViewChild, OnInit, TemplateRef, Inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SecurityHelperService } from 'src/app/security/services/security-helper.service';
import { SubjectObligedService } from 'src/app/services';
import { xlModalConfig } from 'src/app/settings/ngx-modal-settings';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss'],
})
export class ContactModalComponent implements OnInit {
  @ViewChild('templateModal', { static: false }) modal?: TemplateRef<any>;
  modalRef: BsModalRef | null = null;

  constructor(
    private modalService: BsModalService, 
    private subjectObligedService: SubjectObligedService,
    private securityHelperService: SecurityHelperService,
    @Inject('ALDDA_MX_URL') private alddaMxUrl: string,) {}

  ngOnInit() {}

  openModal() {
    this.modalRef = this.modalService.show(this.modal as TemplateRef<any>, xlModalConfig);
  }

  closeModal(): void {
    this.modalRef.hide();
  }

  openZoom() {
    this.subjectObligedService.getZoomLink().subscribe((response) => {
      window.open(response);
      // window.open('https://zoom.us/j/96346085419?pwd=V2dJWlN4b0QvZERQYUc4elFINTNhUT09');
    });
  }

  goToHelpCenter(){
    const token = this.securityHelperService.token;
    const subjectObligedId = this.securityHelperService.subjectObligedId;

    window.open(`${this.alddaMxUrl}#/login?subjectId=${subjectObligedId}&token=${token}&requestType=helpCenter`, '__blank');
  }
}
